import { render, staticRenderFns } from "./DgorderComment.vue.js?vue&type=template&id=3026c1db!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/index.js??vue-loader-options!./DgorderComment.vue?vue&type=template&id=3026c1db"
import script from "./DgorderComment.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/index.js??vue-loader-options!./DgorderComment.vue?vue&type=script&lang=js"
export * from "./DgorderComment.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/index.js??vue-loader-options!./DgorderComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports